import { useEffect, useMemo, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { CheckingLogin } from "./controll_login";
import { httpConfig } from "./httpConfig";
import DBconnect from "./config/dbconnect";
import moment from "moment";
import Swal from "sweetalert2";
import { showURL } from "./config/studentpicURL";
import { RequestFetch } from "./config/requestFetch";
import { ProtectedLogin } from "./protectedlogin";
import { Addmetatags } from "./config/addmetatags";
import { decodeDataforkey } from "./config/encodelocalstorage";
import { CheckWorkAdvisor } from "./config/checkWorkAdvisor";

const WardroundGroupListpage = (props) => {
  // ตั้งค่าตัวแปร
  const http = httpConfig();

  const navigat = useNavigate();
  const cookie = new Cookies();
  const usertoken = cookie.get("tokenEstimate");

  const advisorData = JSON.parse(localStorage.getItem("advisor"));

  const [dataStudent, setDataStudent] = useState([]);
  const [sheetDetail, setSheetDetail] = useState([]);
  const [highlightList, setHighlightList] = useState([]);
  const [statusHighlight, setStatusHighlight] = useState(false);
  const [localHl, setLocalHl] = useState([]);
  const [groupname, setGroupname] = useState();
  const { grp, sheet, workId } = useParams();
  const [pointStudent, setPointStudent] = useState([]);

  const filterWorklocalStorage = localStorage.getItem("filterWork")
    ? JSON.parse(localStorage.getItem("filterwork"))
    : "";

  // const docment = (id) => {
  //   return document.getElementById(id);
  // };

  // เช็คการเข้าสู่ระบบ
  // CheckingLogin().then((res) => {
  //   if (!res) {
  //     console.log("ต้องออกจากระบบ");
  //     Swal.fire({
  //       icon: "error",
  //       title: "!!เข้าสู่ระบบล้มเหลว!!",
  //       text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
  //       showConfirmButton: false,
  //       timer: 1400,
  //     });
  //     setTimeout(() => {
  //       window.location.href = "/estimate";
  //     }, 1400);
  //   }
  // });

  ProtectedLogin(2);

  // ดึงข้อมูลนักศึกษาตามกลุ่ม
  function fetchStudentGroup() {
    // console.log(advisorData.advisor_id, grp);
    // DBconnect.studentINgroup(grp, advisorData.advisor_id).then((res) =>
    //   res.json().then((data) => {
    //     setGroupname(data[0].groupname);
    //     setDataStudent(data);
    //   })
    // );
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        group: grp,
        // id: advisorData.advisor_id,
      }),
    };
    let bodystudentin = {
      group: grp,
    };
    // console.log("กลุ่มนศพ", bodystudentin);
    fetch(
      `${http}/studentINgroup`,
      RequestFetch("POST", bodystudentin, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("dataDetail studentIngroup =>", data);
        if (!data[0]) {
          Swal.fire({
            icon: "warning",
            title: "ไม่พบข้อมูลนักศึกษา !!!",
            text: "ไม่พบข้อมูลนักศึกษาที่อยู่ในกลุ่มการประเมินนี้",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2200,
          });
          navigat(`/listWork?timestamp=${new Date().getTime()}`);
        }
        setGroupname(data[0] ? data[0].groupname : "");
        setDataStudent(data);
      })
    );
  }

  //ดึงข้อมูลประเภทของงานประเมิน (sheet)
  function fetchSheetDetail() {
    if (!sheet) return;
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ id: sheet }),
    };

    let bodyrequest = {
      id: sheet,
    };

    fetch(`${http}/sheet`, RequestFetch("POST", bodyrequest, usertoken)).then(
      (res) =>
        res.json().then((data) => {
          // console.log("ข้อมูลเอาไป set SheetDetail >>", data);
          setSheetDetail(data);
        })
    );
  }

  //เพิ่ม workDetail
  function fetchAddWorkDetail(idWK, idSTD, advisorID) {
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        workId: idWK,
        studentId: idSTD,
        advisorId: advisorID,
      }),
    };

    let bodyrequest = {
      workId: idWK,
      studentId: idSTD,
      advisorId: advisorID,
    };
    fetch(
      `${http}/confirmAddWorkdetail`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((message) => {
        console.log(message);
      })
    );
  }

  // ลบ workDetail
  function fetchDashWorkdetail(wkID, stID, advID) {
    let requestCheck = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        idwork: wkID,
      }),
    };

    let requestOption = {
      method: "DELETE",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        workID: wkID,
        studentID: stID,
        advisorID: advID,
      }),
    };
    let bodyrequestdetailchk = {
      workID: wkID,
      studentID: stID,
      advisorID: advID,
    };
    let bodydashoff = {
      workID: wkID,
      studentID: stID,
      advisorID: advID,
    };

    fetch(
      `${http}/workDetailCheckAssessment`,
      RequestFetch("POST", bodyrequestdetailchk, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        let localHighlight = localStorage.getItem("highlight")
          ? JSON.parse(localStorage.getItem("highlight"))
          : "";
        if (data[0]) {
          data.map((ele) => {
            if (!ele.score) {
              if (ele.student_id === stID) {
                // console.log("ลบเลยอ้ายบ่าว", wkID, stID, advID);
                fetch(
                  `${http}/dashOffWorkdetail`,
                  RequestFetch("DELETE", bodydashoff, usertoken)
                ).then((res) =>
                  res.json().then((message) => {
                    console.log(message);
                  })
                );
              }
            }
          });
        }
      })
    );
  }

  //จัดการข้อมูล highlight เมื่อเลือก
  function highlightStudent(mode, idStudent, group, sheetID, studentId) {
    const docment = (id) => {
      return document.getElementById(id);
    };
    switch (mode) {
      case "pin":
        // console.log("studentId ==>", workId, studentId, advisorData.advisor_id);

        fetchAddWorkDetail(workId, studentId, advisorData.advisor_id);

        if (!highlightList[0]) {
          setStatusHighlight(false);
        }

        setHighlightList([
          ...highlightList,
          {
            group: group,
            studentID: idStudent,
            sheetId: sheetID,
            workId: parseInt(workId),
          },
        ]);

        // docment(`pin-${idStudent}`).style.display = "none";
        // docment(`pin-fill-${idStudent}`).style.display = "block";
        // docment(`img-list-${idStudent}`).style.boxShadow =
        //   "5px 8px 12px #a3e9a4";
        docment(`icon-choose-${idStudent}`).style.display = "none";
        docment(`icon-cancle-${idStudent}`).style.display = "block ";
        docment(`img-list-${idStudent}`).style.border = "3px solid #039be5";
        docment(`name-listInfo-${idStudent}`).style.color = "#039be5";
        break;
      case "unpin":
        // console.log("delete ==>", workId, studentId, advisorData.advisor_id);
        fetchDashWorkdetail(workId, studentId, advisorData.advisor_id);

        let arr = [];
        highlightList.map((hl, index) => {
          // console.log("---->", hl, idStudent);
          if (hl.studentID !== idStudent) {
            arr.push(hl);
          }
        });
        if (!arr[0]) {
          setStatusHighlight(true);
        }
        setHighlightList(arr);
        // docment(`pin-${idStudent}`).style.display = "block";
        // docment(`pin-fill-${idStudent}`).style.display = "none";
        // docment(`img-list-${idStudent}`).style.boxShadow =
        //   "5px 8px 12px #bdbdbd";
        docment(`icon-cancle-${idStudent}`).style.display = "none ";
        docment(`icon-choose-${idStudent}`).style.display = "block";
        docment(`img-list-${idStudent}`).style.border = "none";
        docment(`name-listInfo-${idStudent}`).style.color = "#414040";
        break;
    }
  }

  //เมื่อคลิกไปต่อ
  function handleContinueAssessment() {
    let dataHL = JSON.parse(localStorage.getItem("highlight"));
    let idStudent;

    if (dataHL[0]) {
      idStudent = dataHL[0].studentID;
      dataHL.map((res) => {
        if (res.workId.toString() === workId.toString()) {
          if (res.sheetId.toString() === sheet.toString()) {
            navigat(
              `/grouplistHL/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
            );
          }
        }
      });
    } else {
      return;
    }

    // console.log("dataLocalhost==>", dataHL, idStudent);
    // navigat(`/assessment/${idStudent}/${grp}/${sheet}/${workId}`);
  }

  // เช็คการประเมินนศพ
  function checkAssageMentStudent(IdStudent, sheetId) {
    // console.log("*****************", workId);
    let requestCheckAssessment = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        IdSdt: IdStudent,
        Idsheet: sheetId,
        workID: workId,
      }),
    };

    let bodycheckAss = {
      IdSdt: IdStudent,
      Idsheet: sheetId,
      workID: workId,
    };

    fetch(
      `${http}/checkassessmentstudent`,
      RequestFetch("POST", bodycheckAss, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        if (data[0]) {
          if (data[0].sheetID.toString() === sheetId.toString()) {
            document.getElementById(
              `cardStudent-${data[0].student_id}`
            ).style.borderBottom = "1px solid #a3e9a4";
          }
        } else {
          // console.log("is empty");
        }
      })
    );
  }

  const scoreArr = []; //ตัวแปรทำงานใน fetchScore
  //---------this point----------------
  //ดูคะแนน นศพ
  async function fetchScore(studentId, workId, index, lenghtdata) {
    let datadetailscore = {
      IdStudent: studentId,
      Idwork: workId,
    };

    await fetch(
      `${http}/WorkDetailScore`,
      RequestFetch("POST", datadetailscore, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        if (!data[0]) {
          scoreArr.push({ studentId: studentId, point: "" });
          return;
        }
        if (data[0]) {
          // console.log("this data have point ", data, workId);
          let stID,
            num = 0,
            object = {};
          data.map((data, index) => {
            stID = data.studentID;
            num = num + data.score;
          });
          object = { studentId: stID, point: num };
          // let objecttoHL = { group: grp, studentID: idStudent, sheetId: sheet };
          scoreArr.push(object);
        }
      })
    );
    if (scoreArr.length === lenghtdata) {
      // console.log("เอาค่านี้ไปใช้แทน !!!", scoreArr);
      setPointStudent(scoreArr);
    }
  }

  //fecth รูป api พี่พู
  //เครื่องเบอร์สามทดสอบ
  //อย่าลืมทำเรื่องรับโทเคน
  async function fetchImageStudent(info) {
    let testToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Inp6IiwiZXhwIjoxNjg2MjA5NTcyfQ.pTqmq-5D-8h-atGZX0SxEwe80vkJ0o1lGCTdVWK_MwY";
    let request = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${testToken}`,
      },
      body: JSON.stringify({ std_id: info }),
    };
    let bodyrequest = {
      std_id: info,
    };
    let http = `https://datasoft.co.th/mvc_eye_depart/get_image_student`;

    try {
      // let result = await fetch(http, request).then((res) => {
      //   return res.json();
      // });
      // return result;
      let omg = await fetch(http, request).then((res) =>
        res.json().then((data) => {
          return data.url;
        })
      );
      return omg;
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    // console.log("PIN--->", highlightList);
    if (highlightList[0]) {
      localStorage.setItem("highlight", JSON.stringify(highlightList));
      // console.log("ข้อมูลเลือกแล้ว", highlightList);
    }
    if (statusHighlight) {
      localStorage.setItem("highlight", JSON.stringify(highlightList));
    }
    if (localStorage.getItem("advisor")) {
      let storageAdvisor = JSON.parse(localStorage.getItem("advisor"));
      // console.log("ตอนนี้ดูรายการของ advisor >>>>", storageAdvisor);
      CheckWorkAdvisor(storageAdvisor.advisor_id, workId, usertoken).then(
        (res) => {
          if (!res) {
            navigat("/page404");
          }
        }
      );
    }
  }, [highlightList]);

  useEffect(() => {
    const docment = (id) => {
      return document.getElementById(id);
    };
    if (dataStudent[0]) {
      let arr = [];
      dataStudent.map(async (data, index) => {
        // console.log("datastudent=>", data);
        fetchScore(data.Id, workId, index, dataStudent.length); //จัดการคะแนนโชว์
        arr.push(await handleURLfetch(data.studentID.trim(), index));
        checkAssageMentStudent(data.Id, sheet); //แสดงสีเมื่อมีคะแนน
      });
    }
    setTimeout(() => {
      if (localHl[0]) {
        // console.log("this localHL =>", localHl);
        localHl.map((data) => {
          // console.log(data.workId, workId);
          if (data.workId.toString() === workId.toString()) {
            if (data.sheetId.toString() === sheet.toString()) {
              if (data.group.toString() === grp.toString()) {
                docment(`icon-choose-${data.studentID}`).style.display = "none";
                docment(`icon-cancle-${data.studentID}`).style.display =
                  "block ";
                docment(`img-list-${data.studentID}`).style.border =
                  "3px solid #039be5";
                docment(`name-listInfo-${data.studentID}`).style.color =
                  "#039be5";
              }
            }
          }
        });
      }
    }, 200);
  }, [dataStudent]);

  useEffect(() => {
    if (dataStudent[0]) {
      dataStudent.map((data) => {
        checkAssageMentStudent(data.Id, sheet); //แสดงสี เมื่อมีคะแนน
      });
    }
  }, [pointStudent]);

  async function handleURLfetch(id, key) {
    let URL = await fetchImageStudent(id.trim());
    let result = `http://${URL}`;
    let object = { key: key, url: result, id: id };
    // console.log(")))>", object);
    return object;
  }

  useEffect(() => {
    // Addmetatags();
    if (!grp || grp === "null") {
      if (!grp || grp === "null") {
        Swal.fire({
          icon: "error",
          title: "!!ไม่มีกลุ่มนักศึกษาที่จะทำการประเมินในครั้งนี้!!",
          text: "กรุณาตรวจสอบข้อมูลกลุ่มนักศึกษา",
          showConfirmButton: false,
          timer: 1800,
        });
        navigat(`/listWork?timestamp=${new Date().getTime()}`);
      }
    }
    fetchStudentGroup();
    fetchSheetDetail();

    let highlight = JSON.parse(localStorage.getItem("highlight"));

    if (highlight) {
      // console.log(highlight);
      setHighlightList(highlight);
      setLocalHl(highlight);
    }
    if (!usertoken) {
      Swal.fire({
        icon: "error",
        title: "!!เข้าสู่ระบบล้มเหลว!!",
        text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
        showConfirmButton: false,
        timer: 1400,
      });
      setTimeout(() => {
        window.location.href = "/estimate";
        cookie.remove("tokenEstimate");
      }, 1400);
    }
  }, []);

  return (
    <div className="wardround-list-page">
      <div className="nav-wardround-student">
        <div className="box-relative-nav">
          <i
            className="icon-footer-nav bi-chevron-left"
            onClick={() => {
              navigat(`/listWork?timestamp=${new Date().getTime()}`);
              // localStorage.removeItem("highlight");
            }}
          ></i>
        </div>
        <div className="box-title-nav">
          <span>{sheetDetail[0] ? sheetDetail[0].name : ""}</span>
          {/* <span style={{ fontSize: "15px" }}>กลุ่ม {groupname}</span> */}
        </div>
        <div className="box-relative-nav">
          <i
            className="icon-footer-nav bi-x"
            style={{ fontSize: "26px" }}
            onClick={() => {
              navigat(`/listWork?timestamp=${new Date().getTime()}`);
            }}
          ></i>
        </div>
      </div>
      <div className="content-wardround-list">
        {pointStudent[0] ? (
          dataStudent[0] ? (
            dataStudent.map((data, id) => (
              <div className="card-box" key={id} id={`cardStudent-${data.Id}`}>
                <div className="img-list-wardround">
                  <img
                    className="img-student-omg"
                    //api p_pu
                    // src={
                    //   testPic[id] ? showURL(data.studentID) : console.log("NO")
                    // }
                    src={showURL(data.studentID)}
                    // src={main(data.studentID)}
                    // src={`https://datasoft.co.th/estimate/image/student/${
                    //   filterWorklocalStorage
                    //     ? filterWorklocalStorage.ayear
                    //     : moment(new Date()).format("YYYY")
                    // }/${data.studentID.trim()}.jpg`}
                    id={`img-list-${data.studentID.trim()}`}
                    width={50}
                    height={50}
                  ></img>
                </div>
                <div
                  className="info-img-list-wardround"
                  id={`name-listInfo-${data.studentID.trim()}`}
                >
                  <p className="nameStudent">{`${data.studentname.trim()}  ${
                    data.studentlname
                  }`}</p>
                </div>
                <div className="show-score">
                  <p>
                    {pointStudent[0]
                      ? pointStudent.map((ele) => {
                          if (ele.studentId === data.Id) {
                            return ele.point;
                          }
                        })
                      : ""}
                  </p>
                </div>
                <div className="btn-choose-highlight">
                  <i
                    className="bi-plus i-icon-highlightPlus"
                    id={`icon-choose-${data.studentID.trim()}`}
                    onClick={() => {
                      highlightStudent(
                        "pin",
                        data.studentID.trim(),
                        grp,
                        sheet,
                        data.Id
                      );
                    }}
                  ></i>
                  <i
                    className="bi-check i-icon-highlightCheck"
                    id={`icon-cancle-${data.studentID.trim()}`}
                    onClick={() => {
                      highlightStudent(
                        "unpin",
                        data.studentID.trim(),
                        grp,
                        sheet,
                        data.Id
                      );
                    }}
                  ></i>
                </div>
              </div>
            ))
          ) : (
            <div className="loading-box">
              <div className="just-loading-page">
                <div className="loader"></div>
                <span>{`Loading...`}</span>
              </div>
            </div>
          )
        ) : (
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        )}
      </div>
      <div className="footer-nav-btn">
        <button
          type="button"
          className="btn-continue"
          onClick={() => {
            handleContinueAssessment();
          }}
        >
          {`ต่อไป >`}
        </button>
      </div>
    </div>
  );
};

export default WardroundGroupListpage;
